import { createStore } from 'vuex'
import createVuexPersistedState from 'vuex-persistedstate';
import { LOCAL_STORAGE_KEY } from '@/utils/const';
import { persistedStateStorage } from '@/utils/support_session';
import account from './modules/account';
import organization from './modules/organization';
import error from './modules/error';
import template from './modules/template';
import donation from './modules/donation';
import folder from './modules/folder';
import screen from './modules/screen';
import announcement from './modules/announcement';
import customFont from './modules/custom_font';
import sidenav from './modules/sidenav';
import yurtzeiten from './modules/yurtzeiten';
import yurtzeitenTemplate from './modules/yurtzeiten_template';
import yurtzeitenEmailTemplate from './modules/yurtzeiten_email_template';
import yurtzeiten_N from './modules/yurtzeiten_N';
import yurtzeiten_design_N from './modules/yurtzeiten_design_N';
import recentPhoto from './modules/recent_photo';
import event from './modules/event';
import eventTemplate from './modules/event_template';
import weeklyEvent from './modules/weekly_event';
import weeklySchedule_N from './modules/weekly_schedule_N';
import photoUnderline from './modules/photo_underline';
import ticket from './modules/ticket';
import ticketComment from './modules/ticket_comment';
import dateTimeBanner from './modules/date_time_banner';
import zmanim from './modules/zmanim';
import zmanim_N from './modules/zmanim_N';
import screenArtboard from './modules/screen_artboard';
import zmanimDisplayOverride_N from './modules/zmanim_display_override_N';
import room from './modules/room';
import minyanRoll_N from './modules/minyan_roll_N';
import minyan_N from './modules/minyan_N';

export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    account,
    announcement,
    customFont,
    dateTimeBanner,
    donation,
    folder,
    error,
    event,
    eventTemplate,
    minyan_N,
    minyanRoll_N,
    organization,
    recentPhoto,
    room,
    screen,
    sidenav,
    template,
    ticket,
    ticketComment,
    weeklyEvent,
    weeklySchedule_N,
    photoUnderline,
    yurtzeiten,
    yurtzeitenTemplate,
    yurtzeitenEmailTemplate,
    yurtzeiten_N,
    yurtzeiten_design_N,
    screenArtboard,
    zmanim,
    zmanim_N,
    zmanimDisplayOverride_N
  },
  plugins: [
    createVuexPersistedState({
      key: LOCAL_STORAGE_KEY,
      // This frame's own storage during a support session (utils/support_session).
      storage: persistedStateStorage(LOCAL_STORAGE_KEY),
      paths: ['account'],
    }),
  ],
})
